import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
/**
 * Schema Service
 */
export class SchemaService {
  /**
   * Script type - jsonld
   */
  static scriptType = 'application/json+ld';

  /**
   * Website Schema object
   * @param url string
   * @param name string
   */
  static websiteSchema = (url?: string, name?: string) => {
    return {
      '@context': 'http://schema.org',
      '@type': 'website',
      url: url || '',
      name: name || '',
    };
  };

  /**
   * Organisation Schema object
   * @param url string
   * @param name string
   */
  static orgSchema = () => ({
    '@context': 'https://schema.org',
    '@type': 'Organization',
    url: 'https://www.franklintempleton.com/',
    name: 'Franklin Templeton',
  });

  /**
   * Person Schema object
   * @param url string
   * @param name string
   */
  static personSchema = (name?: string, jobTitle?: string, image?: string) => {
    return {
      '@context': 'http://www.schema.org',
      '@type': 'Person',
      name: name || '',
      image: image || '',
      jobTitle: jobTitle || '',
    };
  };

  /**
   * Constructor
   * @param documentRef Injected document
   */
  constructor(@Inject(DOCUMENT) private documentRef: Document) {}

  /**
   * This function removes all structured data from a page,
   * this should be called when a user navigates away from a page.
   */
  removeStructuredData(): void {
    const els = [];
    ['structured-data', 'structured-data-profile'].forEach((c) => {
      els.push(...Array.from(this.documentRef.head.getElementsByClassName(c)));
    });
    els.forEach((el) => this.documentRef.head.removeChild(el));
  }

  /**
   * Checks to see if `structured-data`element exists, if the element
   * exists we will inject schema, if not we will create a new element.
   * @param schema - Schema object
   * @param className - Class name to be added to script tag
   */
  insertSchema(schema: Record<string, any>, className: string): void {
    let script;
    let shouldAppend = false;
    if (this.documentRef.head.getElementsByClassName(className).length) {
      script = this.documentRef.head.getElementsByClassName(className)[0];
    } else {
      script = this.documentRef.createElement('script');
      shouldAppend = true;
    }
    script.setAttribute('class', className);
    script.type = SchemaService.scriptType;
    script.text = JSON.stringify(schema);
    if (shouldAppend) {
      this.documentRef.head.appendChild(script);
    }
  }
}
